import { styled } from '@mui/material/styles'
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material'
import React from 'react'

export const GreenChartTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '.9rem',
  },
}))
